import type { FC, ReactNode } from 'react'

import classNames from 'classnames'

import './WizardModal.scss'

interface WizardModalLayoutProps {
  children: ReactNode
  className?: string
}

interface WizardModalProgressBarProps {
  barClassName?: string
  className?: string
  isIndeterminate?: boolean
  value?: number
}

export const WizardModalLayout: FC<WizardModalLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <div className={classNames('wizard-modal-layout', className)}>
      {children}
    </div>
  )
}

export const WizardModalStepContent: FC<WizardModalLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <div className={classNames('wizard-modal-step-content', className)}>
      {children}
    </div>
  )
}

export const WizardModalFooter: FC<WizardModalLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <div className={classNames('wizard-modal-footer', className)}>
      {children}
    </div>
  )
}

export const WizardModalFooterNav: FC<WizardModalLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <div className={classNames('wizard-modal-footer-nav', className)}>
      {children}
    </div>
  )
}

export const WizardModalProgressState: FC<WizardModalLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <div className={classNames('wizard-modal-progress-state', className)}>
      {children}
    </div>
  )
}

export const WizardModalProgressBar: FC<WizardModalProgressBarProps> = ({
  barClassName,
  className,
  isIndeterminate,
  value = 0,
}) => {
  return (
    <div
      className={classNames(
        'wizard-modal-progress',
        { 'is-indeterminate': isIndeterminate },
        className,
      )}
    >
      <div
        className={classNames('wizard-modal-progress__bar', barClassName)}
        style={isIndeterminate ? undefined : { width: `${value}%` }}
      />
    </div>
  )
}
